<template>
    <div class="ui-tabs">
        <div class="ui-tabs__nav-container">
            <div class="ui-tabs__nav">
                <div
                    v-for="tab in tabs"
                    :key="tab.name"
                    :class="['ui-tabs__nav-item', { 'ui-tabs__nav-item_active': tab.name === modelValue }]"
                    @click="selectTab(tab.name)"
                >
                    {{ tab.label }}
                </div>
            </div>
        </div>

        <div class="ui-tabs__content">
            <slot></slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, defineProps, defineEmits, computed, getCurrentInstance, watchEffect, provide } from 'vue';

    const props = defineProps({
        modelValue: {
            type: String,
            required: true,
        },
    });

    const emit = defineEmits(['update:modelValue']);

    interface Tab {
        name: string,
        label: string,
    }

    const activeTab = computed(() => props.modelValue);
    const tabs = ref<Tab[]>([]);
    const instance = getCurrentInstance();
    const slots = instance?.slots;

    watchEffect(() => {
        const tabVNodes = slots?.default?.() || [];
        tabs.value = tabVNodes.map((vnode) => {
            const props = vnode.props as any;

            return { name: props.name, label: props.label };
        });
    });

    provide('activeTab', activeTab);

    function selectTab(name: string): void {
        emit('update:modelValue', name);
    }
</script>

<style scoped lang="scss">
    @use './UITabs.scss' as *;
</style>
